import { UserLogged } from '@fichaje/interfaces/userLogged.interface';

export type UserRole = 'super' | 'superadmin' | 'admin' | 'coordinador' | 'administracion';

export type RoleFlag = 'is_super' | 'is_superadmin' | 'is_admin' | 'is_coordinador' | 'is_administracion';

export const ROLE_FLAGS: Readonly<Record<UserRole, RoleFlag>> = {
  super:          'is_super',
  superadmin:     'is_superadmin',
  admin:          'is_admin',
  coordinador:    'is_coordinador',
  administracion: 'is_administracion',
};

/** Todos los roles conocidos. */
export const USER_ROLES = Object.keys(ROLE_FLAGS) as UserRole[];

/** Roles con acceso a la administración (selector de empresa, /tools). */
export const ADMIN_ROLES: UserRole[] = ['super', 'superadmin', 'admin'];

/** true si el usuario tiene al menos uno de los roles indicados. */
export function hasAnyRole(user: UserLogged | null | undefined, roles: UserRole[]): boolean {
  if (!user) return false;
  return roles.some(role => user[ROLE_FLAGS[role]] === true);
}

/** Ruta de inicio según rol: los admins van al menú y el resto al fichaje. */
export function defaultRouteFor(user: UserLogged | null | undefined): '/menu' | '/fichaje' {
  return hasAnyRole(user, ADMIN_ROLES) ? '/menu' : '/fichaje';
}
